import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { ServicenowConnector } from '../../connector';

export const ServicenowService = IntegrationService.make({
  connector: ServicenowConnector,
  name: Integration_Service_Names_Enum.Servicenow,
});
